export default {
  data () {
    return {
      mode: 'view'
    }
  },
  watch: {
    '$route.query' () {
      this.updateMode()
    }
  },
  mounted () {
    this.updateMode()
  },
  methods: {
    updateMode () {
      const { mode } = this.$route.query
      this.mode = mode || 'view'
    }
  }
}
